import { BaseService } from 'core/services';
import ApplicationSettingRouteService from './ApplicationSettingRouteService';

class ApplicationSettingService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ApplicationSettingRouteService());
    }
}

export default ApplicationSettingService;
